import React, { Fragment } from 'react'
import { Button } from '@styles/button.style'
import { GmoneyIco } from '@shared/Icon/MoneyIcon'
import { ChargingEvent, EventWrapper } from '@views/Popup/MatchupBanner/index.style'
import { observer } from 'mobx-react'
import useRootStore from '@store/useRootStore'
import { useOnMount } from '@utils/reactExt'
import { formatNumber, showToast, TOAST_TYPE } from '@utils/utils'
import { isMobile } from 'react-device-detect'

const PaymentRewardEvent: React.FC = () => {
  const { componentStore, userStore, authStore, globalStore } = useRootStore()
  const { paymentReward } = userStore
  const { authInfo } = authStore

  const imageUrl = globalStore.getIngameImagesUrl()

  const guideImageFileName = paymentReward?.guideImage ?? 'pb_guide_1.jpg'
  const guideImageUrl = `${imageUrl}banner/payback/${guideImageFileName}`    // 안내 이미지
  const noticeImageFileName = paymentReward?.noticeImage ?? 'pb_notice_1.jpg'
  const noticeImageUrl = `${imageUrl}banner/payback/${noticeImageFileName}`  // 유의사항

  useOnMount(() => {
    if (componentStore.selectedGameBanner.order === 3) {
      userStore.fetchPaymentReward()
    }
  })

  const receivedReward = (reward) => {
    if (!authStore.isSignedIn) {
      return
    }

    if (reward.isReceived === false) {
      if (paymentReward.monthTotalPayment >= reward.rewardAmountStandard) {
        userStore.receivedPaymentReward(reward.rewardId)
      } else {
        showToast(TOAST_TYPE.INFO, '다음 보상까지 남은 금액을 확인해 주세요.')
      }
    }
  }

  let elements = []
  const additionalElements = []

  if (paymentReward) {
    for (const reward of paymentReward.paymentRewardInfos) {
      const btnClassName = reward.isReceived ? 'receive-btn complete' : 'receive-btn'
      elements.push(<li key={reward.desc} className="event-list--item">
        <p>
          {reward.isNew && <img src={`${imageUrl}banner/payback/pybk_new.png`} alt="새로운 보상 목록" className="new-list"/>}
          {reward.desc}
        </p>
        <Button TP className={btnClassName} onClick={() => receivedReward(reward)}>
          <span className="value">{formatNumber(reward.rewardVolume)}<GmoneyIco/></span>
          <span className="receive-txt">받기</span>
          <span className="complete-txt">완료</span>
        </Button>
      </li>)
    }
    elements = [...additionalElements, ...elements]
  }

  const onClickCharge = () => {
    let url = `${isMobile ? process.env.HOMEPAGE_MO : process.env.HOMEPAGE_PC}`
    if (authStore.isSignedIn) {
      url = `${url}/#/auth_login/${authInfo?.authKey}/payment`
    }

    globalStore.toMoveWebHomePage(url)
  }

  const bgHeight = 245 + (elements.length * 46)

  return (
    <EventWrapper>
      <img src={guideImageUrl} alt="페이백 이벤트 안내"
           className="event-bg"/>
      <div style={{ position: 'relative', marginTop: '-1px' }}>
        <img src={`${imageUrl}banner/payback/pb_bg.jpg`} alt="흰색 배경" className="event-bg"
             style={{ height: `${bgHeight}px` }}/>
        <ChargingEvent>
          <div className="payment-info-wrap">
            <h4 className="event-tit my-info">{paymentReward ? `${paymentReward.baseMonth}월 나의 결제정보` : '이번 달 나의 결제정보'}</h4>
            <ul className="payment-list">
              <li className="payment-list--item">
                <span className="txt">이번 달 결제금액</span>
                <span
                  className="money">{(paymentReward && authStore.isSignedIn) ? `${formatNumber(paymentReward.monthTotalPayment)} 원` : '-'}</span>
              </li>
              <li className="payment-list--item">
                <span className="txt">다음 보상까지 남은 금액</span>
                <span className="money remainder">
                {(paymentReward && authStore.isSignedIn) ? <Fragment><span
                  className="remain-payment">{formatNumber(paymentReward.remainPayment)}</span>원</Fragment> : '-'}
                  <Button onClick={onClickCharge} className="charge-btn">
                  <img src={`${imageUrl}banner/payback/scash_btn_payback.png`} alt="충전"/>
                </Button>
              </span>
              </li>
            </ul>
          </div>
          <div className="payment-info-wrap">
            <h4 className="event-tit">보상 받기</h4>
            <ul className="event-list">
              {elements}
            </ul>
          </div>
        </ChargingEvent>
      </div>

      <img src={noticeImageUrl} alt="이벤트 유의사항"
           className="event-bg"/>
    </EventWrapper>
  )
}

export default observer(PaymentRewardEvent)
